// extracted by mini-css-extract-plugin
export var active = "_cz-7";
export var container = "_cz-0";
export var evenWidth = "_cz-4";
export var large = "_cz-5";
export var outlet = "_cz-8";
export var slide = "_cz-2";
export var small = "_cz-6";
export var tab = "_cz-3";
export var tabs = "_cz-1";